<template>
  <div class="template-item flex flex-align-center">
    <div class="img flex-no-shrink">
      <span class="svg-wrapper">
        <img
          :src="(item || {}).image || ''"
          alt=""
        >
      </span>
    </div>
    <span class="text-smaller" v-html="displayLabel"></span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      default: () => {},
      type: Object,
    },
  },

  computed: {
    displayLabel() {
      return (this.item || {}).display_label || (this.item || {}).title || '';
    },
  },
}
</script>

<style scope>
.template-item {
  cursor: pointer;
  padding: .25em .25em .25em .5em;
  width: 100%;
}
.template-item > .img {
  width: 48px;
}
.template-item > span {
  line-height: 1.2em;
  padding-left: .5em;
}

.selected-item .template-item > .img {
  width: 36px;
}

.dropdown .template-item:hover {
  background-color: #dee7ef;
  color: #222;
}

.dropdown .current-item {
  background-color: #00549d;
  color: #FFF;
}
</style>
